import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class ActionsApi {
  static actionResolve(id) {
    return axios.put(ApiEndpoints.actionResolve.replace(':id:', id));
  }

  // ------ Action Type API ------
  static getAllActions(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.actionList, { params });
  }

  static getAction({ id }) {
    return axios.get(ApiEndpoints.action.replace(':id:', id));
  }

  static createAction(params) {
    return axios.post(ApiEndpoints.actionList, params);
  }

  static updateAction(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.action.replace(':id:', id), data);
  }

  static deleteAction({ id }) {
    return axios.delete(ApiEndpoints.action.replace(':id:', id));
  }

  static getAllActionTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.actionTypeList, { params });
  }

  static getActionType({ id }) {
    return axios.get(ApiEndpoints.actionType.replace(':id:', id));
  }

  static createActionType(params) {
    return axios.post(ApiEndpoints.actionTypeList, params);
  }

  static updateActionType(data) {
    const { id } = data;
    return axios.put(ApiEndpoints.actionType.replace(':id:', id), data);
  }

  static deleteActionType({ id }) {
    return axios.delete(ApiEndpoints.actionType.replace(':id:', id));
  }

  static getAllActionPriorities(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.actionPriorityList, { params });
  }

  static getAllActionStatus(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.actionStatusList, { params });
  }

  static getAllActionContext(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.actionContextList, { params });
  }
}

export default ActionsApi;
